export default __webpack_public_path__ + "static/media/dans-480.a84154f7.jpg";